import type { JSX } from 'react';
import { Alert } from '@ksyos/design-system';
import { CustomControlCode } from '@common/enums';
import { holterZorgdomeinExaminationRequestSections } from '@common/validation/customControls/cardiology/holter/holterZorgdomeinExaminationRequestSchemas';
import { getPatientAlternativeAddressComponents } from '@frontend/components/pages/episodeCategory/customControls/patientContactDetails/getPatientAlternativeAddressComponents';
import { EditForm } from '@frontend/formEngine/editForm/EditForm';
import { getPatientContactDetailsComponent } from '../../../patientContactDetails/getPatientContactDetailsComponent';
import { HolterExaminationFollowingSteps } from '../customComponents/HolterExaminationFollowingSteps';
import { getExaminationRequestInputComponentsBase } from '../utils/getExaminationRequestInputComponentsBase';
import { getMedicationInputComponents } from '../utils/getMedicationInputComponents';
import { getReferralDataInputComponents } from '../utils/getReferralDataInputComponents';

export function HolterZorgdomeinExaminationRequestEdit(): JSX.Element {
    const alert = (
        <Alert appearance="info">
            De recorder wordt opgestuurd naar onderstaand adres. De patiënt ontvangt hiervan een track & trace e-mail.
        </Alert>
    );

    const inputComponents = new Map([
        ...getExaminationRequestInputComponentsBase(),
        ...getMedicationInputComponents(),
        ...getPatientContactDetailsComponent({ alert, showAddress: true }),
        ...getPatientAlternativeAddressComponents(),
        ...getReferralDataInputComponents(),
    ]);

    return (
        <>
            <EditForm
                inputComponents={inputComponents}
                sections={holterZorgdomeinExaminationRequestSections}
            />

            <HolterExaminationFollowingSteps holterType={CustomControlCode.HolterZorgdomeinExaminationRequest} />
        </>
    );
}
